import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { DestinationAvatarComponent } from './destination-avatar.component';

@NgModule({
  declarations: [
    DestinationAvatarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule
  ],
  exports: [
    DestinationAvatarComponent
  ]
})
export class DestinationAvatarModule { }
